import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "components/Context/AuthContext";

export default function AuthenticatedProfile({ showLogout = true }) {
    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();

    // Retrieve username from sessionStorage, fallback to null
    const dummyUsername = sessionStorage.getItem("username");
    const userRole = sessionStorage.getItem("userRole");

    const handleResetPassword = (event) => {
        event.preventDefault();
        navigate("/resetPasswordafterlogin");
    };

    // Navigate to the User Approval page
    const handleUserApproval = (event) => {
        event.preventDefault();
        navigate("/userapproval");
    };

    // Navigate to the Update Entitlement page
    const handleUpdateEntitlement = (event) => {
        event.preventDefault();
        navigate("/updateentitlement");
    };
    // Navigate to the Upload Security page
    const handleUploadSecurity = (event) => {
        event.preventDefault();
        navigate("/pageUploadSecurity");
    };

    
    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Logged out");
        logout()
        navigate("/home");
    };

    return (
        <>
        <div id="profile-menu"
            className="absolute right-0 mt-2 w-auto min-w-[200px] max-w-[300px] border border-gray-300 bg-gray-300 rounded shadow-lg overflow-hidden"
            style={{ zIndex: 9999 }} // Ensure it is on top
        >
            {/* Username Section */}
            <div className="p-4 border-b border-gray-200">
                <p className="text-sm text-gray-600">Username</p>
                    <p
                        className="text-base font-semibold text-gray-800 truncate"
                        title={dummyUsername} // Tooltip for full username
                        style={{
                        maxWidth: "280px", // Ensure truncation works
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        }}
                    >
                    {dummyUsername}
                </p>
            </div>

            {/* User Aproval */}
            {
                userRole === 'superadmin' && (
                    <div className="p-4">
                    <button
                        onClick={handleUserApproval}
                        className="text-indigo-700 hover:underline font-medium text-left"
                    >
                        User Approval
                    </button>
                </div>
    
                )
            }

            {/* Update Entitlement */}
            {
                (userRole === 'superadmin' || userRole === 'admin') && (
                    <div className="p-4">
                    <button
                        onClick={handleUpdateEntitlement}
                        className="text-indigo-700 hover:underline font-medium text-left"
                    >
                        Update Entitlement
                    </button>
                </div>
    
                )
            }

            {/* Upload New Security */}
            {
                (userRole === 'superadmin') && (
                    <div className="p-4">
                    <button
                        onClick={handleUploadSecurity}
                        className="text-indigo-700 hover:underline font-medium text-left"
                    >
                        Upload Security
                    </button>
                </div>
    
                )
            }

            {/* Reset Password Section */}
            <div className="p-4">
                <button
                    onClick={handleResetPassword}
                    className="text-indigo-700 hover:underline font-medium text-left"
                >
                    Change Password
                </button>
            </div>

            {/* Logout Section */}
            {showLogout && (
                <div className="p-4">
                    <button
                        onClick={handleLogout}
                        className="text-indigo-700 hover:underline font-medium"
                    >
                        LOGOUT
                    </button>
                </div>
            )}
        </div>
        </>
    );

}